import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ searchNow?: boolean }>()(theme => ({
  tabelWrapper: {
    display: 'flex',
    minWidth: theme.spacing(83),
    padding: theme.spacing(0, 5, 3, 5),
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    borderRadius: theme.spacing(1),
    background: theme.palette.bg.main,
    boxSizing: 'border-box',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  radioButton: {
    '& .MuiFormGroup-root': {
      flexDirection: 'column',
      gap: '10px',
    },
  },
  totalNetRevenue: {
    color: theme.palette.shadows.dark,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    marginTop: theme.spacing(3),
  },
  filterWrapper: {
    alignSelf: 'end',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
    height: theme.spacing(6.5),
  },
  alignFilters: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  filter: {
    alignSelf: 'center',
  },
  justifySpaceBetween: {
    justifyContent: 'space-between',
  },
  justifyEnd: {
    justifyContent: 'flex-end',
  },
  totalPrice: {
    fontWeight: 500,
  },
}))
